var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5241 0 20 4.47715 20 10L19.9968 10.2542C19.862 15.6607 15.4379 20 10 20L9.7458 19.9968C4.33928 19.862 0 15.4379 0 10L0.00316655 9.7458C0.138006 4.33928 4.56212 0 10 0ZM15.2432 6.38766C14.9256 6.0823 14.41 6.0801 14.0935 6.3845L8.33333 11.9231L5.91176 9.59464C5.58911 9.2844 5.07523 9.28664 4.75684 9.59279L4.74316 9.60593C4.42559 9.91129 4.42605 10.4097 4.74602 10.7173L7.75398 13.6096C8.07269 13.916 8.59124 13.9187 8.90939 13.6128L15.2573 7.50903C15.5752 7.20337 15.5752 6.70695 15.2568 6.4008L15.2432 6.38766Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.f2319b8fc5073033bd58ca3521b84bf7.svg";
export { ForwardRef as ReactComponent };